import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { Response } from '@/types';
import { useMutation } from '@tanstack/react-query';

type PasswordResetProps = {
  email: string;
};

const postPasswordReset = ({
  email,
}: PasswordResetProps): Promise<Response> => {
  const redirectUrl = window.location.origin + '/password-reset/edit';
  return axios.post('/api/v1/auth/password', { email, redirectUrl });
};

type QueryFnType = typeof postPasswordReset;

type Options = {
  config?: MutationConfig<QueryFnType>;
};

export const usePostPasswordReset = ({ config }: Options = {}) => {
  return useMutation({
    ...config,
    mutationFn: postPasswordReset,
  });
};
